import { profileExtension } from '@interhyp/api-account';
import { useIdentity } from '@interhyp/platform-auth';
import { NoticesBannerConnected } from '@interhyp/platform-downtime';
import {
  HeaderPortal,
  MainToolbar,
  Menu,
  MenuItem,
  MenuSpacer,
} from '@interhyp/platform-navigation';
import { Link, matchPath, useLocation } from '@interhyp/platform-router';
import { Logo } from '@platform/theme';
import { useCallback } from 'react';

import styles from './NavBar.module.scss';
import { MobileDrawer } from './components/MobileDrawer';
import { useMainNavigation } from '../../hooks/useMainNavigation';
import { IntentToggle } from '../IntentToggle/IntentToggle';

export function Navbar(): React.ReactElement {
  const { pathname } = useLocation();
  const mainNavigation = useMainNavigation();
  const identity = useIdentity();

  const Profile = profileExtension.useExtension();

  const getMenuItemProps = useCallback(
    (path: string, exact?: boolean) => {
      return {
        to: path,
        active: !!matchPath(pathname, {
          exact,
          path,
        }),
      };
    },
    [pathname],
  );

  return (
    <HeaderPortal>
      <>
        <NoticesBannerConnected tags={['portal-interim-home']} visibility="PRIVATE" />
        <MainToolbar className={styles.toolbar}>
          <Link to="/">
            <Logo className={styles.logo} />
          </Link>

          {identity && (
            <>
              <MenuSpacer />
              <Menu className={styles.menu}>
                <IntentToggle />
                {mainNavigation.map(item => (
                  <MenuItem
                    key={item.path}
                    label={item.label}
                    {...getMenuItemProps(item.path, item.exact)}
                  />
                ))}
              </Menu>

              {Profile && <Profile />}
              <MobileDrawer mainNavigation={mainNavigation} />
            </>
          )}
        </MainToolbar>
      </>
    </HeaderPortal>
  );
}
